import { render, staticRenderFns } from "./busquedasLayout.vue?vue&type=template&id=37f90034&scoped=true&"
import script from "./busquedasLayout.vue?vue&type=script&lang=js&"
export * from "./busquedasLayout.vue?vue&type=script&lang=js&"
import style0 from "./busquedasLayout.vue?vue&type=style&index=0&id=37f90034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f90034",
  null
  
)

export default component.exports